import * as htmlToImage from 'html-to-image';

const convertChartToImage = async (id) => {
  const node = document.getElementById(id);
  const response = await htmlToImage.toPng(node, { height: 400, width: 600 });
  return response;
};

export default convertChartToImage;
